import styled from '@emotion/styled';
import Link from 'next/link';
import React from 'react';
import { breakpoints, colors, spacing } from '../../../../utils/styleguide';
import Typography from '../../text/Typography';
import { NavLinkItemType } from '../navTypes';

const NavigationLinkContainer = styled.div`
  pointer-events: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  ${breakpoints.tablet} {
    flex-direction: row;
  }
`;

const TextLinkItem = styled.div`
  color: ${colors.white};
  max-width: 250px;
  margin-top: ${spacing[7]}px;
  ${breakpoints.tablet} {
    margin-top: 0;
  }
  ${breakpoints.xl} {
    width: 250px;
  }
`;

const ImageLinkItem = styled.div`
  color: ${colors.white};
  margin: ${spacing[8]}px 0 0;
  ${breakpoints.tablet} {
    margin: 0;
  }
  ${breakpoints.desktop} {
    padding: 0 ${spacing[3]}px;
  }
`;

const StoreGroupsItemLinks = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  a {
    margin-right: ${spacing[4]}px;
    :last-child {
      margin-right: 0;
    }
  }
  img {
    width: 105px;
    height: 30px;
    object-fit: contain;
  }
`;

const LinkHeader = styled(Typography)`
  color: ${colors.white};
  margin-bottom: ${spacing[5]}px;
`;

const LinkText = styled.a`
  display: block;
  width: 100%;
  text-decoration: none;
  margin-bottom: ${spacing[3]}px;
  cursor: pointer;
`;

type LinksNavigationProps = {
  textLinks?: NavLinkItemType[];
  imageLinks?: NavLinkItemType[];
};

const NavigationLinks = ({ textLinks, imageLinks }: LinksNavigationProps) => {
  return (
    <NavigationLinkContainer>
      {textLinks?.map(({ links, id, title }) => (
        <TextLinkItem key={id}>
          <LinkHeader variant="preamble">{title}</LinkHeader>
          {links?.map(({ title, content, href }, index) => {
            return (
              <Link href={href as string} passHref={!!href} key={index}>
                <LinkText aria-label={title}>
                  <Typography tag="p" color={colors.white}>
                    {content}
                  </Typography>
                </LinkText>
              </Link>
            );
          })}
        </TextLinkItem>
      ))}
      {imageLinks?.map(({ links, id, title }) => (
        <ImageLinkItem key={id}>
          <LinkHeader variant="preamble">{title}</LinkHeader>
          <StoreGroupsItemLinks>
            {links?.map(({ title, image, href }, index) => {
              return (
                <Link href={href as string} key={index}>
                  <a aria-label={title}>{image}</a>
                </Link>
              );
            })}
          </StoreGroupsItemLinks>
        </ImageLinkItem>
      ))}
    </NavigationLinkContainer>
  );
};

export default NavigationLinks;
